import React from 'react';

export const Plus = React.memo(({ fill }) => (
  <path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M15 5C15.221 5 15.433 5.0878 15.5893 5.24408C15.7455 5.40036 15.8333 5.61232 15.8333 5.83333V14.1667H24.1667C24.3877 14.1667 24.5996 14.2545 24.7559 14.4107C24.9122 14.567 25 14.779 25 15C25 15.221 24.9122 15.433 24.7559 15.5893C24.5996 15.7455 24.3877 15.8333 24.1667 15.8333H15.8333V24.1667C15.8333 24.3877 15.7455 24.5996 15.5893 24.7559C15.433 24.9122 15.221 25 15 25C14.779 25 14.567 24.9122 14.4107 24.7559C14.2545 24.5996 14.1667 24.3877 14.1667 24.1667V15.8333H5.83333C5.61232 15.8333 5.40036 15.7455 5.24408 15.5893C5.0878 15.433 5 15.221 5 15C5 14.779 5.0878 14.567 5.24408 14.4107C5.40036 14.2545 5.61232 14.1667 5.83333 14.1667H14.1667V5.83333C14.1667 5.61232 14.2545 5.40036 14.4107 5.24408C14.567 5.0878 14.779 5 15 5Z'
    fill={fill}
  />
));
Plus.displayName = 'Plus';
